<!--ui结构-->
<template>
  <div id="app">
    <!-- <scale-box :width="1920" :height="1080" bgc="transparent" :delay="100"> -->
      <!-- 头部 -->
      <HiggsHead></HiggsHead>
      <!-- 路由占位符 -->
      <router-view></router-view>
      <!-- 底部 -->
      <HiggsBottom></HiggsBottom> 
    <!-- </scale-box> -->
  </div>
</template>

<!--行为-->
<script>
// import ScaleBox from "vue2-scale-box";
import HiggsHead from './components/HiggsHead'
import HiggsBottom from './components/HiggsBottom'
export default {
  name: 'app',
  data(){
    return {
      scale :1
    }
  },
  components:{
    // ScaleBox, 
    HiggsHead,
    HiggsBottom
  },
  mounted() {
    // var devicewidth = document.documentElement.clientWidth;
    // this.scale = devicewidth / 1920;  // 分母——设计稿的尺寸
    // document.body.style.zoom = this.scale;

    // var that = this;
    // window.onresize = function () { //窗口尺寸变化时，重新计算
    //   var devicewidth = document.documentElement.clientWidth;
    //   var scaleTmp = devicewidth / 1920;  
    //   if(scaleTmp > that.scale){//窗口尺寸变大时，重新缩放
    //     that.scale = scaleTmp;
    //     document.body.style.zoom = that.scale;
    //   } 
    // }
  }
}
</script>

<!--样式-->
<style>
</style>
